import React, { FC } from 'react';
import { SettingsTablePageSkeleton } from '../settings/settingsSkeleton';

export const ReportViewsTryOnPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
